import { motion } from 'framer-motion';
import styled from 'styled-components';

const ExtraBalanceErrorWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const ExtraBalanceErrorCardStyled = styled.div`
  position: relative;
  background: white;
  border-radius: 8px;
  margin-top: 46px;
`;

const ExtraBalanceMessageStyled = styled.div`
  position: relative;
  padding: 20px 25px 20px;
  height: auto;
  background: #ffffff;
  width: 95%;
  margin: auto;
  margin-top: 50px;
  box-shadow: 0px 2px 4px rgba(56, 20, 81, 0.15);
  border-radius: 8px;
`;

const ExtraBalanceInfoStyled = styled.div`
  max-width: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: auto;

  > h2 {
    color: #2d1441;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
  }

  > img {
    margin: 20px 0;
  }

  > p {
    color: #553e65;
    line-height: 24px;
    font-size: 15px;
    @media (min-width: 341px) {
      font-size: 16px;
    }
  }
`;

const ExtraBalanceAlertStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 15px 0 0;
  max-width: 250px;

  > img {
    margin: 4px 10px 0 0;
    height: 16px;
    width: 16px;
  }

  > p {
    color: #e92070;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
  }
`;

const ExtraBalanceMessageErrorStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  position: relative;
`;

const AnimationContainerStyled = styled(motion.div)`
  width: 100%;
`;

export {
  ExtraBalanceErrorWrapperStyled,
  ExtraBalanceErrorCardStyled,
  ExtraBalanceMessageStyled,
  ExtraBalanceInfoStyled,
  ExtraBalanceAlertStyled,
  ExtraBalanceMessageErrorStyled,
  AnimationContainerStyled,
};
